import React from "react";

const RefundProcessingReceipt = ({
  orderReport,
  formatrefundInitiatedTime,
  formatrefundCreditExpectedTime,
  formatpaymentTime,
  step1Img,
}) => {
  const refundInfo = orderReport?.data?.refundDetailInfoList?.[0];
  const items = orderReport?.data?.orderLineItem || [];

  return (
    <>
      <div className="flex space-x-3 mb-4">
        <img src={step1Img} alt="Timeline" className="h-28" />
        <div className="space-y-4">
          <div>
            <p className="font-semibold text-gray-800">Refund Initiated</p>
            <p className="text-xs text-gray-600">
              Refund Reference Number: {refundInfo?.transactionId?.slice(-10)}<br />
              {formatrefundInitiatedTime}
            </p>
          </div>
          <div>
            <p className="font-semibold text-gray-800">Refund Processing By Bank</p>
            <p className="text-xs text-gray-600">
              Expected settlement by {formatrefundCreditExpectedTime}
            </p>
          </div>
        </div>
      </div>

      <div className="rounded-lg p-3 mb-4">
        <p className="text-gray-800 font-semibold">
          <span className="text-gray-500">Amount to be Refunded:</span> ₹ {refundInfo?.refundAmount}
        </p>
        <hr className="my-4" />
        <p className="text-xs text-black/70 font-normal">{formatrefundCreditExpectedTime}</p>
        <p className="text-xs text-black/70 font-normal">Transaction ID: {refundInfo?.transactionId}</p>
        <p className="text-xs text-black/70 font-normal">Refund Account: {refundInfo?.pgName}</p>
      </div>

      <div className="rounded-lg p-3 mb-4">
        <p className="text-gray-800 font-semibold">
          <span className="text-gray-500">Order:</span> {items.length} Items
        </p>
        <hr className="my-3" />
        <div className="grid grid-cols-3 text-center mt-2 font-medium text-gray-600 text-xs pb-1">
          <div className="text-left">Item(Count)</div>
          <div>Price Per Unit</div>
          <div className="mr-6">Status</div>
        </div>

        {items.map((item, index) => (
          <div
            key={index}
            className="grid grid-cols-3 text-center text-gray-800 text-xs mt-1"
          >
            <div className="text-left">
              {item.variantName.length > 20
                ? item.variantName.slice(0, 20) + "..."
                : item.variantName} ({String(item.itemQuantity).padStart(2, "0")})
            </div>
            <div>₹ {item.amount}</div>
            <div className="font-medium">
              {item.successQuantity > 0 && (
                <span className="text-black/70 font-bold">Success({item.successQuantity})</span>
              )}{" "}
              {item.failureQuantity > 0 && (
                <span className="text-red-500 font-bold">Failed({item.failureQuantity})</span>
              )}{" "}
              {item.vendRemaining > 0 && (
                <span className="text-yellow-600 font-bold">Pending({item.vendRemaining})</span>
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="rounded-lg p-3 mb-4">
        <p className="text-gray-800 font-semibold">
          Paid Amount: ₹ {refundInfo?.paidAmount}
        </p>
        <hr className="my-4" />
        <p className="text-xs text-black/70 font-normal">{formatpaymentTime}</p>
        <p className="text-xs text-black/70 font-normal">Transaction ID: {refundInfo?.transactionId}</p>
        <p className="text-xs text-black/70 font-normal mt-2">
          Payment Method: <span className="font-medium">{refundInfo?.payMethod}</span>
        </p>
      </div>

      <hr className="my-6 p-6"  />
    </>
  );
};

export default RefundProcessingReceipt;
